import { Fragment } from "react";
import { useSelector } from "react-redux";
import { FormDatePicker } from "../forms/form-components";
import { DropDownButton } from "@progress/kendo-react-buttons";
import { getJsonDateStringFromDateKey } from "../lib/utils";

const actionRenderer = currentTheme => (props) => {
    if (props.item.actionName == "")
       return <div className="separator" disabled={true} style={{width: "100%", height: 1, borderBottom: `1px solid ${currentTheme.componentBorderColor}`}}></div>;

    return (
      <div>
        {
            props.icon &&
            <span className={`k-icon k-i-${props.item.icon}`} role="presentation" />
        }
        <span style={{paddingLeft: 16}}>{props.item.text}</span>
      </div>
    );
};

export const ProFormDatePicker = props => {
    const {id, onDateKeySelected, ...other} = props;

    const currentTheme = useSelector(state => state.currentTheme);

    return (
        <Fragment>
            <div className={`pro-form-datepicker pro-form-datepicker-${id}`}>
                <FormDatePicker id={id} {...other} />
                <div style={{marginTop: 20, marginLeft: 6, borderRadius: 4, border: `1px solid ${currentTheme.componentBorderColor}`}}>
                    <DropDownButton popupSettings={{popupClass:"pro-form-datepicker-actions"}} 
                        // disabled={pageState.processing || pageState.formValues.IsSystem} 
                        buttonClass="pro-form-datepicker-actions-button"
                        style={{fontSize:18, fontWeight: 700}} fillMode={"flat"} 
                        itemRender={actionRenderer(currentTheme)} items={[]} textField="text" 
                        icon="more-horizontal" 
                        onItemClick={e => {
                            let key = e.item.actionName;
                            let value = getJsonDateStringFromDateKey(key, false);

                            props.onDateKeySelected(key, value);
                        }} 
                    />
                </div>
            </div>
            <style>
            {`
                .pro-form-datepicker
                {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                }

                .pro-form-datepicker .k-form-field
                {
                    flex: 1;
                }
                .pro-form-datepicker:last-child
                {
                    padding-left: 16px;
                }

            `}
            </style>
        </Fragment>       
    );
};